import React, { useEffect, useState } from "react";
import { TableTransaksiComp } from "../../components/";
import { IconInfoCircleFilled } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import axios from "../../lib/axios";
import errorHandler from "../../helpers/errorHandler";
import { useLocation } from "react-router-dom";

const RiwayatTransaksiPage = () => {
  const location = useLocation();
  const [userAccountType, setUserAccountType] = useState("");
  const [transaction, setTransaction] = useState("");

  const handleFetch = async () => {
    try {
      const options = {
        url: `/users/users/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      const { data } = await axios(options);
      if (data.code === "200") {
        setUserAccountType(data.data.Account.type);
      }
    } catch (err) {
      errorHandler({ err: err?.response?.data || err });
    }
  };

  const fetchLastTrx = async () => {
    try {
      const options = {
        url: `/users/transactions/last/desc`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      const { data } = await axios(options);
      if (data.code === "200") {
        setTransaction(data?.data);
      }
    } catch (err) {
      errorHandler({ err: err?.response?.data || err });
    }
  };

  useEffect(() => {
    handleFetch();
    fetchLastTrx();
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      event: "pageview",
      page: {
        url: window.location.pathname + window.location.search,
        title: document.title,
      },
    });
  }, [location]);

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const statusBarTransaksi = useSelector((state) => state.statusBarTransaksi);
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );

  // console.log(transaction)

  return (
    <>
      <h3>Riwayat Transaksi</h3>
      <div className="d-flex justify-content-between">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a
                href="#"
                style={{
                  color: "#B5B5C3",
                }}
              >
                Beranda
              </a>
            </li>
            <li
              class="breadcrumb-item active"
              aria-
              current="page"
              style={{
                color: "#3F4254",
              }}
            >
              Riwayat Transaksi
            </li>
          </ol>
        </nav>

        {transaction?.isEarlyBird === false &&
        transaction.glStatus === "pending" ? (
          // for corporate
          userAccountType === "corporate" ? (
            // for mobile view corporate
            size.width < 500 ? (
              ""
            ) : // for desktop view corporate
            transaction.glFile === null || transaction.receiptFile === null ? (
              <>
                <div
                  className="card"
                  style={{
                    backgroundColor: "#FFEFDD",
                    borderColor: "#FE9D2C",
                  }}
                >
                  <div className="card-body">
                    <div className="row d-flex justify-content-between">
                      <div className="col-lg-1 col-12">
                        <IconInfoCircleFilled
                          width="55px"
                          height="55px"
                          className="text-warning"
                        />
                      </div>
                      <div className="col-lg-1 col-12"></div>
                      {transaction.glFile === null &&
                      transaction.paymentStatus === "pending" ? (
                        // client corporate belum upload GL
                        <>
                          <div className="col-lg-10 col-12">
                            <h4 className="mt-2 text-warning">
                              Upload Guarantee Letter Pending
                            </h4>
                            <h5>
                              Silahkan selesaikan transaksi dengan Upload
                              Guarantee Letter!
                            </h5>
                          </div>
                        </>
                      ) : transaction.glFile !== null &&
                        transaction.paymentStatus === "pending" ? (
                        // client corporate sudah upload gl tapi belum upload BB
                        <>
                          <div className="col-lg-10 col-12">
                            <h4 className="mt-2 text-warning">
                              Upload Guarantee Letter Berhasil
                            </h4>
                            <h5>
                              Silahkan selesaikan pembayaran dengan Upload Bukti
                              Bayar!
                            </h5>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // client corporate sudah upload gl dan sudah upload BB
              ""
            )
          ) : // for individual
          // for mobile view
          size.width < 500 ? (
            ""
          ) : transaction.receiptFile === null ? (
            // client individu belum upload BB
            <>
              <div
                className="card"
                style={{
                  backgroundColor: "#FFEFDD",
                  borderColor: "#FE9D2C",
                }}
              >
                <div className="card-body">
                  <div className="row d-flex justify-content-between">
                    <div className="col-lg-1 col-12">
                      <IconInfoCircleFilled
                        width="55px"
                        height="55px"
                        className="text-warning"
                      />
                    </div>
                    <div className="col-lg-1 col-12"></div>
                    <div className="col-lg-10 col-12">
                      <h4 className="mt-2 text-warning">
                        Upload Bukti Bayar Pending
                      </h4>
                      <h5>
                        Silahkan selesaikan transaksi dengan Upload Bukti Bayar!
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            // client sudah individu upload udah upload BB
            ""
          )
        ) : (
          ""
        )}
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-lg-12">
          <TableTransaksiComp userAccountType={userAccountType} />
        </div>
      </div>
    </>
  );
};

export default RiwayatTransaksiPage;
